import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  fetchCollectionGroups,
  hideCollectionGroupEditModal,
} from '../../actions/Collections';

import {
  APIcreateCollectionGroup,
  APIupdateCollectionGroup,
} from '../../api/Collections';

import { sendTrackingEvent } from '../../helpers';

import ErrorBoundary from '../ErrorBoundary';

class CollectionGroupEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this.collectionGroupNameInput = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSaveCollectionGroup = this.handleSaveCollectionGroup.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  getInitialState() {
    return {
      collectionGroupName: '',
      collectionGroupBadge: '',
      collectionGroupInSidebar: false,
      errors: {},
      saving: false,
    };
  }

  componentDidMount() {
    const { collectionGroup } = this.props;

    if (collectionGroup) {
      this.setState({
        collectionGroupName: collectionGroup.name,
        collectionGroupBadge: collectionGroup.badge,
        collectionGroupInSidebar: collectionGroup.in_sidebar,
      });
    }

    sendTrackingEvent('collection-group-modal-open');

    setTimeout(() => {
      this.collectionGroupNameInput.focus();
    }, 100);
  }

  validateForm() {
    const { intl } = this.props;
    const { collectionGroupName } = this.state;
    const errors = {};

    if (!collectionGroupName) {
      errors.collectionGroupName = intl.formatMessage({
        defaultMessage: 'This field is required',
      });
    }

    this.setState({ errors });

    if (Object.keys(errors).length > 0) {
      return false;
    }

    return true;
  }

  handleChange(e) {
    const {
      name,
      value,
      checked,
      type,
    } = e.target;

    if (type === 'checkbox') {
      this.setState({ [name]: checked });
    } else {
      this.setState({ [name]: value });
    }
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.handleSaveCollectionGroup();
    }
  }

  handleSaveCollectionGroup() {
    if (!this.validateForm()) {
      return;
    }

    const {
      collectionGroupName,
      collectionGroupBadge,
      collectionGroupInSidebar,
    } = this.state;
    const {
      collectionGroup,
      loadCollectionGroups,
      afterCreateCollectionGroup,
      notificationCallback,
    } = this.props;

    this.setState({ saving: true });

    if (collectionGroup) {
      const updatedCollectionGroup = Object.assign({}, collectionGroup);
      updatedCollectionGroup.name = collectionGroupName;
      updatedCollectionGroup.badge = collectionGroupBadge;
      updatedCollectionGroup.in_sidebar = collectionGroupInSidebar;

      APIupdateCollectionGroup(updatedCollectionGroup).then((response) => {
        if (response.data) {
          notificationCallback(response.data);
          afterCreateCollectionGroup(response.data);
        }
        loadCollectionGroups();
        this.setState(this.getInitialState());
        this.handleCloseModal();
      });
    } else {
      APIcreateCollectionGroup({
        name: collectionGroupName,
        badge: collectionGroupBadge,
        in_sidebar: collectionGroupInSidebar,
      }).then((response) => {
        notificationCallback(response.data);
        if (response.data && response.data.id) {
          afterCreateCollectionGroup(response.data);
        }
        sendTrackingEvent('collection-group-created');
        loadCollectionGroups();
        this.setState(this.getInitialState());
        this.handleCloseModal();
      });
    }
  }

  handleCloseModal() {
    const {
      closeCollectionGroupEditModal,
      handleClose,
    } = this.props;

    closeCollectionGroupEditModal();
    handleClose();
  }

  render() {
    const {
      collectionGroupName,
      collectionGroupBadge,
      collectionGroupInSidebar,
      errors,
      saving,
    } = this.state;
    const {
      intl,
      collectionGroup,
    } = this.props;

    return (
      <ErrorBoundary>
        <ModalHeader toggle={this.handleCloseModal} className="modal-header-center">
          {collectionGroup ? (
            intl.formatMessage({ defaultMessage: 'Edit Collection Group' })
          ) : (
            intl.formatMessage({ defaultMessage: 'New Collection Group' })
          )}
        </ModalHeader>
        <ModalBody>
          <Form
            className="new-collection-form"
            onKeyPress={this.handleKeyPress}
          >
            <FormGroup>
              <Label for="inpCollectionGroupName">
                {intl.formatMessage({ defaultMessage: 'Collection group name' })}
              </Label>
              <Input
                type="text"
                name="collectionGroupName"
                id="inpCollectionGroupName"
                placeholder={intl.formatMessage({ defaultMessage: 'Collection group name' })}
                autoFocus={true}
                innerRef={(ref) => { this.collectionGroupNameInput = ref; }}
                value={collectionGroupName}
                onChange={this.handleChange}
                invalid={errors.collectionGroupName !== undefined}
              />
              <FormFeedback>
                {errors.collectionGroupName}
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="inpCollectionGroupBadge">
                {intl.formatMessage({ defaultMessage: 'Collection group badge (optional)' })}
              </Label>
              <Input
                type="text"
                name="collectionGroupBadge"
                id="inpCollectionGroupBadge"
                placeholder={intl.formatMessage({ defaultMessage: 'Collection group badge' })}
                value={collectionGroupBadge}
                onChange={this.handleChange}
              />
              <FormFeedback>
                {errors.collectionGroupName}
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="inpCollectionGroupInSidebar" check>
                <Input
                  type="checkbox"
                  name="collectionGroupInSidebar"
                  id="inpCollectionGroupInSidebar"
                  className="input-check check-s form-check-input"
                  checked={collectionGroupInSidebar}
                  onChange={this.handleChange}
                />
                {' '}
                {intl.formatMessage({ defaultMessage: 'show in sidebar' })}
              </Label>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            disabled={saving}
            onClick={this.handleCloseModal}
          >
            {intl.formatMessage({ defaultMessage: 'Cancel' })}
          </Button>
          {' '}
          <Button
            color="primary"
            disabled={saving}
            onClick={this.handleSaveCollectionGroup}
          >
            {
              saving ?
                intl.formatMessage({ defaultMessage: 'Saving...' }) :
                intl.formatMessage({ defaultMessage: 'Save' })
            }
          </Button>
        </ModalFooter>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  collectionGroups: state.Collections.collectionGroups,
});

const mapDispatchToProps = dispatch => ({
  closeCollectionGroupEditModal: () => {
    dispatch(hideCollectionGroupEditModal());
  },
  loadCollectionGroups: () => (
    dispatch(fetchCollectionGroups())
  ),
});

CollectionGroupEditModal.propTypes = {
  intl: PropTypes.object.isRequired,
  handleClose: PropTypes.func,
  collectionGroup: PropTypes.object,
  closeCollectionGroupEditModal: PropTypes.func.isRequired,
  loadCollectionGroups: PropTypes.func.isRequired,
  afterCreateCollectionGroup: PropTypes.func,
  notificationCallback: PropTypes.func,
};

CollectionGroupEditModal.defaultProps = {
  collectionGroup: null,
  handleClose: () => {},
  afterCreateCollectionGroup: () => {},
  notificationCallback: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CollectionGroupEditModal));
